import React, { useCallback, useState } from "react"
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import { useMobile } from "../../../../hooks/system/useMobile";
import { UserRow } from "../../hooks/useUserLoader";
import { useApi } from "../../../../hooks/useApi";
import { PasswordResetRequestFormData } from "../../../security/PasswordResetRequestForm";

export interface ConfirmResetPasswordEmailProps {
  activeUser: UserRow
  open: boolean
  onClose: () => void
}
//i might need to change the props above
export const ConfirmManualResetPasswordEmail = (p: ConfirmResetPasswordEmailProps) => {
  const isMobile = useMobile('sm'),
    { api } = useApi();

  const [ chosenEmail, setChosenEmail ] = useState<string>("phoenix@blockfills.com");

  const onClose = useCallback(() => {
    setChosenEmail("phoenix@blockfills.com");
    p.onClose();
  }, [p,setChosenEmail])

  const onSubmit = useCallback(async () => {
    const data: PasswordResetRequestFormData = {email: p.activeUser.email, chosenEmail: chosenEmail};
    api.postSecurityRequestPasswordReset({requestPasswordReset: data}).then(() => p.onClose())
  }, [api, p,chosenEmail])

  return (
    <Dialog open={p.open} onClose={onClose} maxWidth='sm' fullWidth fullScreen={isMobile}>
      <DialogTitle>Are you sure you want to manually reset client's password?</DialogTitle>
      <DialogContent>
        <label htmlFor='emailinput'> This will send a password reset email to    </label>
          <input id = 'emailinput' value={chosenEmail}  onChange={e => setChosenEmail(e.target.value)} />
          </DialogContent>
      <DialogActions>
          <Button size="small" onClick={onClose}>
            <Box m={[0, 1]}>Cancel</Box>
          </Button>
          <Button size="small" onClick={onSubmit}>
            <Box m={[0, 1]}>Submit Password Reset</Box>
          </Button>
        </DialogActions>
    </Dialog>
  )
}
